<section id="login-aliado" class="login-if">
  <app-header-public variant="v2" [showAuthButtons]="false" [showRegisterButton]="false"></app-header-public>

  <div class="login-if__vigilado" aria-hidden="true">
    <img class="login-if__vigilado-img" src="assets/img/Home/hero/Ico_super.svg" alt="" />
  </div>

  <main class="login-if__main">
    <div class="login-if__hero">
      <div class="login-if__bg" aria-hidden="true"></div>
      <div class="login-if__visual-mobile" aria-hidden="true">
        <span class="login-if__bubble login-if__bubble--tl-lg"></span>
        <span class="login-if__bubble login-if__bubble--tl-sm"></span>
        <img class="login-if__visual-mobile-img" src="assets/img/login/login-if-mobile.png" alt="" />
      </div>

      <h1 class="login-if__hero-title">Inicio de sesión</h1>

      <span class="login-if__bubble login-if__bubble--br-lg login-if__bubble--desktop" aria-hidden="true"></span>
      <span class="login-if__bubble login-if__bubble--br-sm login-if__bubble--desktop" aria-hidden="true"></span>

      <div class="login-if__panel">
        <span class="login-if__bubble login-if__bubble--tl-lg login-if__bubble--desktop" aria-hidden="true"></span>
        <span class="login-if__bubble login-if__bubble--tl-sm login-if__bubble--desktop" aria-hidden="true"></span>

        <form class="login-if__form" [formGroup]="loginForm" (ngSubmit)="validateForm()" novalidate>
          <div class="login-if__field" [class.login-if__field--invalid]="validateField('idTipoDocIdentidad')">
            <label class="login-if__label" for="idTipoDocIdentidad">Tipo de documento*</label>
            <select id="idTipoDocIdentidad" class="login-if__control" formControlName="idTipoDocIdentidad"
              (change)="validarSelect()" [class.is-invalid]="validateField('idTipoDocIdentidad')" required>
              <option value="">Seleccione una opción</option>
              @for (documento of listaDocumentos; track documento.idTipoDocIdentidad) {
              <option [value]="documento.idTipoDocIdentidad">
                {{ documento.nombre }}
              </option>
              }
            </select>
            <div class="login-if__error">Campo obligatorio</div>
          </div>

          <div class="login-if__field" [class.login-if__field--invalid]="validateField('numeroDocumento')">
            <label class="login-if__label" for="numeroDocumento">Número de documento*</label>
            <input id="numeroDocumento" class="login-if__control" autocomplete="off" type="text" maxlength="15"
              formControlName="numeroDocumento" appNumeroDocumentoPorTipo [tipos]="documentosParaValidacion"
              idTipoDocControlName="idTipoDocIdentidad" [class.is-invalid]="validateField('numeroDocumento')"
              required />
            @if (loginForm.get('numeroDocumento')?.hasError('documentPattern')) {
            <div class="login-if__error">{{ mensajeErrorNumeroDocumento }}</div>
            } @else {
            <div class="login-if__error">Campo obligatorio</div>
            }
          </div>

          <div class="login-if__field" [class.login-if__field--invalid]="validateField('password')">
            <label class="login-if__label" for="password">Contraseña*</label>
            <div class="login-if__password">
              <input id="password" class="login-if__control" autocomplete="off" maxlength="20"
                [type]="isVisible ? 'text' : 'password'" formControlName="password"
                [class.is-invalid]="validateField('password')" />
              <button class="login-if__password-toggle" type="button" (click)="showPassword()"
                [attr.aria-label]="isVisible ? 'Ocultar contraseña' : 'Mostrar contraseña'">
                <span [class]="isVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"></span>
              </button>
            </div>
            <div class="login-if__error">
              Campo obligatorio (Debe tener como mínimo 8 caracteres, 1
              mayúscula, 1 minúscula, 1 número y 1 caracter especial
              (&#64;$+#!%*?&-/_.,))
            </div>
          </div>

          <div class="login-if__actions">
            <a routerLink="/activar-usuario" class="login-if__btn login-if__btn--secondary" id="btn-login-if-activar"
              (click)="trackLinkCta('Activa tu usuario', 'btn-login-if-activar')">
              Activa tu usuario
            </a>
            <button type="submit" class="login-if__btn login-if__btn--primary" id="btn-login-if-iniciar">
              Inicia sesión
            </button>
          </div>
        </form>

        <nav class="login-if__links" aria-label="Acciones de cuenta">
          <a routerLink="/recordar" class="login-if__link" id="btn-login-if-olvidaste"
            (click)="trackLinkCta('¿Olvidaste tu contraseña?', 'btn-login-if-olvidaste')">
            ¿Olvidaste tu contraseña?
          </a>
          <a routerLink="/desbloquear" class="login-if__link" id="btn-login-if-desbloquear"
            (click)="trackLinkCta('Desbloquea tu usuario', 'btn-login-if-desbloquear')">
            Desbloquea tu usuario
          </a>
        </nav>
      </div>
    </div>
  </main>

  <app-home-site-footer></app-home-site-footer>
  <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
</section>